import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { TX_STATUS_COMPLETED, TX_STATUS_FAILED, TX_STATUS_HOLD } from '../../config'
import { holdReasonLabel, transactionStateLabel } from '../../utils/display_names'

const STATE_BOX_CLASSES = {
  [TX_STATUS_FAILED]: 'bg-danger p-xs',
  [TX_STATUS_COMPLETED]: 'bg-primary p-xs',
}

const HOLD_BOX_STYLE = { fontSize: 11, cursor: 'default', color: 'white' }

class IdStatus extends PureComponent {
  render() {
    // currentState - coming from API call, newState - coming from state update action
    const { newState, currentState, holdReason } = this.props
    const state = newState || currentState

    if (state === TX_STATUS_HOLD) {
      return (
        <StatusBox>
          <span className='p-xs label label-warning' style={HOLD_BOX_STYLE}>
            {holdReasonLabel(holdReason)}
          </span>
        </StatusBox>
      )
    }

    const boxClass = Object.prototype.hasOwnProperty.call(STATE_BOX_CLASSES, state)
      ? STATE_BOX_CLASSES[state]
      : 'bg-success p-xs'

    return (
      <StatusBox>
        <span className={boxClass} style={{ cursor: 'default' }}>
          {transactionStateLabel(state) || 'N/A'}
        </span>
      </StatusBox>
    )
  }
}

const StatusBox = ({ children }) => (
  <div>
    <div className='ibox-title'>
      <h5>Status</h5>
    </div>
    <div className='ibox-content text-center text-uppercase'>{children}</div>
  </div>
)

const mapStateToProps = (state) => ({
  newState: state.modalConfirmation.newState,
  isFetching: state.txById.isFetching,
})

export default connect(mapStateToProps)(IdStatus)
